<template>
    <div class="btn" :class="display">
        <router-link v-if="route" :to="goTo" @click="handleClick">
            <div v-if="iconLeft" class="icon icon-left" :style="iconLeftStyle"></div>
            <div class="text"><slot></slot></div>
            <div v-if="iconRight" class="icon icon-right" :style="iconRightStyle"></div>
        </router-link>
        <a v-else :href="goTo" @click="handleClick">
            <div v-if="iconLeft" class="icon icon-left" :style="iconLeftStyle"></div>
            <div class="text"><slot></slot></div>
            <div v-if="iconRight" class="icon icon-right" :style="iconRightStyle"></div>
        </a>
    </div>
</template>
<script>
    export default {
        name: 'Btn',
        props: {
            route: {
                type : Boolean,
                default : true
            },
            disabled: Boolean,
            block: Boolean,
            to: String,
            iconLeft: String,
            iconRight: String
        },
        computed: {
            goTo(){
                return this.to || ""
            },
            display(){
                return {
                    'block' : this.block,
                    'disabled' : this.disabled
                }
            }
        },
        methods: {
            iconLeftStyle(){
                return { 'background-image' : 'url(' + this.iconLeft + ')' }
            },
            iconRightStyle(){
                return { 'background-image' : 'url(' + this.iconRight + ')' }
            },
            handleClick( event ){
                if( !this.disabled ){
                    this.$emit( "clicked", { event, route: this.route, to: this.to } )
                }else{
                    this.$emit( "disabled" )
                    event.preventDefault()
                }
            }
        }
        
    }
</script>
<style lang="scss" scoped>
    @import "../scss/vars";

    .btn {
        border-radius: 4px;
        overflow: hidden;
        display: inline-block;
        font-size: 1.4rem;

        &.block{
            display: block;
        }

        &.disabled{
            a{
                background-color: $pale-gray;
                &:hover{
                    background-color: $pale-gray;
                }
            }
        }

        a{
            display: flex;
            align-items: center;
            justify-content: space-between;
            font-size: 1em;
            background: $red;
            color: white;
            text-decoration: none;
            text-align: center;
            font-weight: bold;
            text-transform: uppercase;
            cursor: pointer;
            padding: 1rem;
            transition: background-color $speed ease;

            &:hover{
                background-color: $blue;
            }

            .text{
                padding: 0 1rem;
                flex-grow: 1;
                white-space: nowrap;
            }
        }

        .icon{
            width: 2.2rem;
            height: 2.2rem;
            background-color: white;
            background-position: center;
            background-repeat: no-repeat;
            background-size: contain;
        }
    }
    
</style>